import React, { useEffect, useState } from "react";
import OfferItem from "../components/OfferItem";
import axios from "axios";
import { GET_BASE_URL } from "../utils/Constants";
import '../index.css';
import ProgressStepper from "../components/ProgressStepper";


const OffersScreen = ({ platform, nicheName, imageUrl, offersList }) => {



    const [offers, setOffers] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);
    const [changeISP, setChangeISP] = useState({
        isValid: true,
        msg: ""
    });

    const [selectedOffer, setSelectedOffer] = useState(null);

    const [openDetailsOffer, setOpenDetailsOffers] = useState(false);


    useEffect(() => {
        const updateHeight = () => setHeight(window.innerHeight);
        window.addEventListener("resize", updateHeight);

        if (!showLoading) fetchOffers()

        return () => window.removeEventListener("resize", updateHeight);

    }, []);


    const fetchOffers = async () => {
        try {
            setShowLoading(true)
            // Example API call (you can replace this with your actual API)
            const response = await axios.get(GET_BASE_URL() + "offers.php", {
                params: {
                    niche_name: nicheName
                }
            });

            setOffers(response.data);


            console.log(response.data);

        } catch (error) {

            console.log("Error fetching data", error);
        } finally {

        }
    };



    const canOpenUrl = async (offer) => {
        setShowLoading(true)
        try {
            // Example API call (you can replace this with your actual API)
            const response = await axios.get(GET_BASE_URL() + "url_check.php", {
                params: {
                    url: offer.link
                }
            });


            const isAccessible = Boolean(response.data.isValid);

            if (isAccessible === false) {
                setChangeISP({
                    isValid: false,
                    msg: response.data.status
                })
            } else {
                //window.location.href = urlLink;
                // window.open(urlLink, "_blank")
                setSelectedOffer(offer);
                setOpenDetailsOffers(true);
            }
        } catch (error) {
            console.log("Error fetching data", error);
        } finally {
            setShowLoading(false)
        }
    };

    const handleOfferLink = (offer) => {
        // canOpenUrl(offer)
        setSelectedOffer(offer);
        setOpenDetailsOffers(true);
    };

    const handleComplete = () => {
        setShowLoading(false)
        // redirect, show popup, etc.
    };

    return (
        <div
            class="relative z-20 overflow-y-scroll fade-in"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
        >


            <div
                style={{ height: height }}
                class="fixed inset-0   transition-opacity w-screen p-[12px] overflow-y-auto  bg-gradient-to-r from-semi-blue to-light-blue"
                aria-hidden="true"
            >

                <img className="h-[64px] w-[64px] bg-white mx-auto mt-[16px] rounded-xl fade-in"

                    src={GET_BASE_URL() + "images/" + imageUrl}
                />



                <div className="semiBold text-[22px] mt-[8px] text-white mx-auto text-center fade-in">{nicheName}</div>



                {!showLoading &&
                    <div className="text-white mx-4 mt-[8px] p-4 medium bg-semi-blue text-center mb-[16px] rounded-3xl bg-gradient-to-r from-dark-blue to-semi-blue fade-in">


                        <p className="semiBold text-[22px] text-green-600">

                            DOWNLOAD COMPLETED
                        </p>
                        <h1 className="bold text-base">


                            <span className="semiBold text-[16px] text-yellow-800">

                                To proceed with the {platform} installation, please complete 1 or 2 tasks from the list below.
                            </span>


                        </h1>


                    </div>
                }





                {
                    showLoading &&

                    <ProgressStepper
                        onComplete={handleComplete}

                    />
                }



                {!showLoading && offers.map((item) => (
                    <OfferItem
                        key={item.id}
                        offer={item}
                        onOfferClick={handleOfferLink}
                    />

                ))}
            </div>

            {!changeISP.isValid &&
                <div className="fixed inset-0 bg-gray-800  bg-opacity-75  mx-auto flex items-center justify-center px-[16px]">
                    <div className="bg-white p-6 rounded-2xl shadow-lg max-w-md w-full text-center">
                        <h2 className="text-xl semiBold text-gray-800 mb-4">
                            Connectivity Issue
                        </h2>
                        <p className="text-gray-800 medium mb-6">
                            {changeISP.msg}
                        </p>
                        <button
                            className="bg-semi-blue text-white py-2 medium px-4 rounded-3xl hover:bg-blue-600 transition-colors w-full"
                            onClick={() => setChangeISP(
                                {
                                    isValid: true,
                                    msg: ""
                                }
                            )}
                        >
                            Understood
                        </button>
                    </div>
                </div>
            }

            {
                openDetailsOffer && <div>
                    <div className="fixed inset-0 bg-gray-800  bg-opacity-75  mx-auto flex items-center justify-center px-[16px]">

                        <div className="bg-white relative p-6 rounded-2xl shadow-lg max-w-md w-full text-center">
                            <div className="absolute top-0 right-0 bold text-2xl  px-[12px]"
                                onClick={() =>
                                    setOpenDetailsOffers(false)
                                }
                            >X</div>
                            <div className="absolute top-0 left-0 bg-blue-500 text-white py-[4px] px-[28px] bold bg-semi-blue rounded-tl-2xl rounded-br-2xl">
                                Free
                            </div>
                            <img
                                src={selectedOffer.picture}
                                alt="Placeholder"

                                className="w-[52px] h-[52px] rounded-lg object-cover mx-auto mt-[8px]"
                            />
                            <h2 className="text-xl semiBold text-gray-800 mb-[8px]">
                                {selectedOffer.name_short}
                            </h2>
                            <p className="text-gray-800 medium mb-6">
                                {selectedOffer.adcopy}
                            </p>
                            <a
                                href={selectedOffer.link}
                                target="_blank">
                                <div className="relative">


                                    <button
                                        className="bg-custom-blue text-white py-2 medium px-4 w-full rounded-3xl hover:bg-blue-600 transition-colors animate-bounce"
                                        onClick={() =>
                                            setOpenDetailsOffers(false)
                                        }
                                    >
                                        Finish
                                    </button>
                                </div>

                            </a>
                        </div>
                    </div>
                </div>
            }
        </div>
    )

}

export default OffersScreen;